// extracted by mini-css-extract-plugin
export default {"title":"D1kfG","block":"PNOvU","inlineParagraph":"lBalS","hidden":"FiGCC","button":"piP3P","chevron":"Yb_sS","active":"vx40Z"};